<script setup>
const props = defineProps({
  color: {
    type: String,
    default: "orange",
  },
  icon: {
    type: String,
  },
  to: {
    type: [String, Object],
  },
  href: {
    type: String,
  },
});
// @unocss-include
const themes = {
  red: "bg-red-400 hover:bg-red-500 active:bg-red-700",
  orange: "bg-orange-400 hover:bg-orange-500 active:bg-orange-700",
  blue: "bg-blue-400 hover:bg-blue-500 active:bg-blue-700",
  stone: "bg-stone-400 hover:bg-stone-500 active:bg-stone-700 disabled:bg-stone-500",
  "light-stone": "text-stone-600 bg-stone-100 hover:(bg-stone-200 text-stone-700) active:(bg-stone-300 text-stone-700)",
  green: "bg-green-500 hover:bg-green-600 disabled:bg-green-500 active:bg-green-700",
};

const theme = computed(() => themes[props.color] || themes.orange);

const component = computed(() => {
  if (props.to || props.href) {
    return resolveComponent("NuxtLink");
  }
  return "button";
});
</script>
<template>
  <component
    :is="component"
    class="text-stone-100 font-mono text-4 px-2 py-1 rounded shadow-stone-200 shadow-md hover:(opacity-90 shadow-stone-300 shadow-md) active:shadow-stone-400 inline-flex gap-2 items-center disabled:(opacity-40 cursor-not-allowed)"
    :class="theme"
    :to="props.to"
    :href="props.href"
    v-bind="$attrs"
  >
    <span v-if="props.icon" class="inline-block" :class="props.icon"></span>
    <slot />
  </component>
</template>
